<template>
    <div>
        <div class="top">
            <img class="img" @click="goBack" src="../assets/image/tc.png" alt="">
            <div class="text" @click="goBack">{{$store.state.textName}}
                -<span class="zb">{{ type.name }}</span>-
                <span class="zy">{{ select.name }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'BackTop',
  data () {
    return {

    }
  },
  props: {
    type: {
      type: Object,
      default: {}
    },
    select: {
      type: Object,
      default: {}
    }
  },
  methods: {
    goBack () {
      this.$router.push({ name: this.type.route })
    }
  }
}
</script>

<style lang="less" scoped>
    .top {
        height: 60px;
        background: @primary-color;
        display: flex;
        line-height: 60px;
        align-items: center;
        padding: 0 50px;

        .img {
            width: 20px;
            height: 20px;
            margin-top: 4px;
            cursor: pointer;
        }

        .text {
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #fff;
            margin-left: 10px;
            line-height: 30px;
            cursor: pointer;
        }

        .zb {
            cursor: pointer;
        }

        .zy {
            cursor: pointer;
        }
    }
</style>
